import React from 'react'
import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import { loadingTypes } from './DotLottie.config';

const DotLottieLoading = (props) => {
    const { type, text } = props;

  return (
     <div className="fixed inset-0 z-50 flex flex-col h-screen w-screen items-center justify-center backdrop-blur-sm">
      {/* <div className="flex flex-col items-center justify-center rounded-3xl px-6 py-5 shadow-lg backdrop-blur dark:border-white/10"> */}
       <div className="relative flex flex-col items-center justify-center">
        <DotLottieReact
          src={loadingTypes[type]?.lottieUrl}
          loop
          autoplay
          className={`${loadingTypes[type]?.style?.icon} mb-2 sm:mb-0`}
        />
        <div className={`${loadingTypes[type]?.style?.text} absolute text-xs sm:text-lg font-bold text-sky-900 dark:text-customWhite`}>
          {text} . . .
        </div>
        </div>
    </div>
  )
}

export default DotLottieLoading;

